import { ReactNode } from "react";
import Sentry from "@/config/sentry";
import { ErrorPage } from "@/components/error-page/error-page";
import { useTranslation } from "react-i18next";

export function IFrameGuard({ children }: { children: ReactNode }) {
  const { t } = useTranslation("common");
  let isFramed = false;

  try {
    if (window.self !== window.top || window.parent !== window) {
      isFramed = true;
    }
  } catch (error) {
    Sentry.captureException(error);
    isFramed = true;
  }

  if (isFramed) {
    return (
      <ErrorPage errorCode={403} message={t("IframeNotAllowed")} description={t("PleaseOpenDirectly")} hideActions />
    );
  }
  return <>{children}</>;
}
